'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// region import React

// endregion
// region import components

// endregion
// region import CSS
// Semantic UI

// Specific CSS


exports.default = Masthead;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactShareButtons = require('@ta-interaktiv/react-share-buttons');

var _reactShareButtons2 = _interopRequireDefault(_reactShareButtons);

require('ta-semantic-ui/semantic/dist/components/grid.css');

require('ta-semantic-ui/semantic/dist/components/container.css');

require('ta-semantic-ui/semantic/dist/components/image.css');

require('./../style/Masthead.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders the masthead component.
 * @param {mastheadProps} props
 * @param {string} [props.mediaName=tagesanzeiger] The media domain name whose
 * logo should be shown.
 * @param {string} [props.fullMediaName=Tages-Anzeiger] The outwards facing
 *   media name.
 * @param {string} [props.homepage=http://www.tagesanzeiger.ch] The home page
 *   of the medium to link to.
 * @param {string} [props.url=window.location.href] The URL to share. Will be
 * overridden by URLs in the {@link communities} array. Passed along to share
 *   buttons component.
 * @param {boolean} [props.inverted=false] Whether the masthead should be
 * displayed inverted, for use on dark backgrounds.
 * @param {string[]} [props.hashtags] Hashtags as an array of strings. Facebook
 *   will only use the first one.
 * @param {communityObject[]} [props.communities] Community objects, as
 * provided by
 *   the External Services API service by Newsnet.
 * @param {function} [props.clickHandler=noop] The action that should be
 * executed when the user clicks the link.
 */

// endregion

/**
 * @module Masthead
 * @version 2.2
 * @example
 * import Masthead from '@ta-interaktiv/react-masthead';
 *
 *  // ...
 *
 *  class YourComponent extends React.Component {
 *   render() {
 *
 *     return (
 *       <Masthead
 *          mediaName='tagesanzeiger'
 *          homepage='//www.tagesanzeiger.ch'
 *          fullMediaName='Tages-Anzeiger'
 *          hashtags={['TAGrafik', 'DDJ']} />
 *     )
 *   }
 * }
 *
 */

/**
 * The community object as provided by the Newsnet API.
 *
 * @property {string} type The identifier of the community (i.e. 'facebook'
 *   or 'twitter')
 * @property {number} count The number of shares of this type.
 * @property {string} share_type_id A GUID that links article and community
 *   type.
 * @property {string} url The canonical URL of the article that should be
 *   used for sharing this article.
 * @property {string} [name] The front facing name of the community.
 * @property {string} [title] The title of the article for sharing.
 * @property {string} [description] The call to action for the community.
 * @property {string} [facebook_id] The Facebook App ID.
 * @property {string} [via] The via account name to use on Twitter.
 */
function Masthead(props) {
  var _props$mediaName = props.mediaName,
      mediaName = _props$mediaName === undefined ? 'tagesanzeiger' : _props$mediaName,
      _props$inverted = props.inverted,
      inverted = _props$inverted === undefined ? false : _props$inverted,
      _props$clickHandler = props.clickHandler,
      clickHandler = _props$clickHandler === undefined ? function () {} : _props$clickHandler,
      _props$homepage = props.homepage,
      homepage = _props$homepage === undefined ? '//www.tagesanzeiger.ch' : _props$homepage,
      _props$fullMediaName = props.fullMediaName,
      fullMediaName = _props$fullMediaName === undefined ? 'Tages-Anzeiger' : _props$fullMediaName,
      _props$url = props.url,
      url = _props$url === undefined ? window.location.href : _props$url;
  // Prepare constants for the inverted version

  var invertedClass = inverted ? 'inverted' : '';
  var invertedImgSrcName = inverted ? '-inverted' : '';

  return _react2.default.createElement(
    'div',
    { className: 'ta-masthead masthead-component ' + invertedClass },
    _react2.default.createElement(
      'div',
      { className: 'ui container ' },
      _react2.default.createElement(
        'div',
        { className: 'ui middle aligned grid' },
        _react2.default.createElement(
          'div',
          { className: 'mobile only three wide column ta-logo' },
          _react2.default.createElement(
            'a',
            { href: homepage },
            ' ',
            _react2.default.createElement('img', {
              src: '//interaktiv.tagesanzeiger.ch/static/icons/' + mediaName + invertedImgSrcName + '.svg',
              alt: fullMediaName,
              className: 'ui middle aligned logo image' }),
            ' '
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'mobile hidden five wide column ta-logo' },
          _react2.default.createElement(
            'a',
            { href: homepage },
            ' ',
            _react2.default.createElement('img', {
              src: '//interaktiv.tagesanzeiger.ch/static/logos/' + mediaName + invertedImgSrcName + '.svg',
              alt: fullMediaName,
              className: 'ui middle aligned logo image' }),
            ' '
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'right aligned right floated thirteen wide mobile eleven wide tablet eleven wide computer column' },
          _react2.default.createElement(_reactShareButtons2.default, _extends({}, props, {
            url: url,
            clickHandler: clickHandler,
            displayType: 'horizontal icons' }))
        )
      )
    )
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@ta-interaktiv/react-masthead/dist/index.js
// module id = 130
// module chunks = 0